import { api } from "@/lib/api";

export interface EventOption {
	id: number;
	name: string;
	slug: string | null;
	description: string | null;
}

export interface FeeCategoryOption {
	id: number;
	name: string;
	code: string;
	allows_other_specify: boolean;
	waiver_field_label: string | null;
	current_fee: number;
}

export interface SubEventOption {
	id: number;
	name: string;
	current_registration_phase: string | null;
	has_workshops: boolean;
	fee_categories: FeeCategoryOption[];
}

export interface WorkshopOption {
	id: number;
	name: string;
	description: string | null;
	fee_categories: FeeCategoryOption[];
}

export interface FacultyOption {
	id: number;
	name: string;
}

export const getEvents = async () => {
	const response = await api.get("/events");
	return response.data;
};

export const getSubEvents = async (eventId: number) => {
	const response = await api.get(`/events/${eventId}/sub-events`);
	return response.data;
};

export const getWorkshops = async (subEventId: number) => {
	const response = await api.get(`/events/sub-events/${subEventId}/workshops`);
	return response.data;
};

export const getFaculties = async () => {
	const response = await api.get("/faculties/list");
	return response.data;
};

export interface SubmitRegistrationData {
	event_id: number;
	sub_event_id: number;
	workshop_id?: number;
	fee_category_id: number;
	title?: string;
	first_name: string;
	last_name: string;
	phone: string;
	email: string;
	faculty_id?: number;
	mdc_number?: string;
	category_other?: string;
	senior_waiver_applied?: boolean;
	payment_method: "card" | "momo";
	momo_mobile_number?: string;
	momo_mobile_network?: "MTN" | "VODAFONE" | "AIRTELTIGO";
}

export interface SubmitRegistrationResponse {
	requires_payment: boolean;
	mode?: "redirect" | "poll";
	redirect_url?: string;
	transaction_uuid: string;
}

export const submitRegistration = async (data: SubmitRegistrationData) => {
	const response = await api.post("/events/registrations", data);
	return response.data as { success: boolean; message: string; data: SubmitRegistrationResponse };
};

export interface TransactionStatusResponse {
	status: string;
	status_label: string;
	amount: string;
	currency: string;
	event_name: string | null;
	sub_event_name: string | null;
}

export const getRegistrationStatus = async (transactionUuid: string) => {
	const response = await api.get(`/events/registrations/${transactionUuid}/status`);
	return response.data as { success: boolean; message: string; data: TransactionStatusResponse };
};
